import React from 'react';
import { IconContainer } from './IconContainer';

const CodeIcon = (props) => {
    return (
        <IconContainer ariaLabel="code" { ...props }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path d="M10.9999 11.9998L3.92886 19.0708L2.51465 17.6566L8.1715 11.9998L2.51465 6.34292L3.92886 4.92871L10.9999 11.9998ZM10.9999 18.9998H20.9999V20.9998H10.9999V18.9998Z" fill="currentColor" />
            </svg>
        </IconContainer>
    )
}

export { CodeIcon };